export const serverErrors: number[] = [500];
